import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '../store/hooks';

// Post-login splash. Routes the operator on once their UI settings arrive:
// waiters (ui_tablet_view) go to the restaurant floor plan, everyone else to
// the phone-order screen. A fallback covers the case where settings never load.
export default function HomePage() {
  const navigate = useNavigate();
  const uiSettingsLoaded = useAppSelector((s) => s.ui.uiSettingsLoaded);
  const tabletView = useAppSelector((s) => s.ui.uiVisibleComponents.ui_tablet_view);

  const loadedRef = useRef(uiSettingsLoaded);
  useEffect(() => { loadedRef.current = uiSettingsLoaded; }, [uiSettingsLoaded]);

  useEffect(() => {
    if (uiSettingsLoaded) {
      navigate(tabletView ? '/tables' : '/order', { replace: true });
      return;
    }
    // Settings haven't arrived yet (socket still connecting). Wait, but never
    // strand the user on the splash if the socket fails outright.
    const t = setTimeout(() => {
      if (!loadedRef.current) navigate('/order', { replace: true });
    }, 2500);
    return () => clearTimeout(t);
  }, [uiSettingsLoaded, tabletView, navigate]);

  return (
    <div className="hc-home-splash">
      <h1 className="hc-home-splash__heading">HalloChef</h1>
      <img
        src="/hallochef.svg"
        alt="HalloChef"
        className="hc-home-splash__logo"
      />
    </div>
  );
}
